if (!customElements.get('el114-album')) customElements.define('el114-album', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.warmObserver?.disconnect();
    this.observer?.disconnect();
    this.abort = new AbortController();
    const { signal } = this.abort;
    const video = this.querySelector('video');
    const button = this.querySelector('.el114-album-video-toggle');
    if (!video || !button) return;
    let manuallyPaused = false, visible = false, nearby = false, pendingPlay = false;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const autoAllowed = () => !reduced.matches && !connection?.saveData;
    const load = () => {
      if (video.dataset.albumLoaded === 'true') return;
      const sources = [...video.querySelectorAll('source[data-src]')];
      const supported = sources.filter(source => video.canPlayType(source.type));
      const mp4 = supported.filter(source => source.type === 'video/mp4');
      const candidates = (mp4.length ? mp4 : supported).sort((a, b) => Number(a.dataset.width || 0) - Number(b.dataset.width || 0));
      const targetWidth = connection?.saveData ? 480 : matchMedia('(max-width: 749px)').matches ? 720 : 1080;
      const source = candidates.find(item => Number(item.dataset.width) >= targetWidth) || candidates.at(-1);
      if (source) {
        source.src = source.dataset.src;
        video.dataset.albumLoaded = 'true';
        video.preload = 'auto';
        video.load();
      }
    };
    const sync = () => {
      button.textContent = video.paused ? 'Play ▷' : 'Pause Ⅱ';
      button.setAttribute('aria-label', video.paused ? 'Play product detail video' : 'Pause product detail video');
      button.setAttribute('aria-pressed', String(!video.paused));
    };
    const play = () => {
      load();
      if (pendingPlay || !video.paused) return;
      pendingPlay = true;
      Promise.resolve(video.play()).catch(() => {}).finally(() => { pendingPlay = false; sync(); });
    };
    const update = () => {
      if (document.hidden) { video.pause(); return; }
      if (nearby && autoAllowed()) load();
      if (visible && !manuallyPaused && autoAllowed()) play();
      else video.pause();
    };
    for (const event of ['play', 'pause', 'error']) video.addEventListener(event, sync, { signal });
    button.addEventListener('click', () => {
      if (video.paused) { manuallyPaused = false; play(); }
      else { manuallyPaused = true; video.pause(); }
    }, { signal });
    document.addEventListener('visibilitychange', update, { signal });
    reduced.addEventListener('change', update, { signal });
    connection?.addEventListener?.('change', update, { signal });
    if ('IntersectionObserver' in window) {
      this.warmObserver = new IntersectionObserver(entries => {
        nearby = entries[0].isIntersecting;
        if (nearby && !document.hidden && autoAllowed()) load();
      }, { rootMargin: '600px 0px' });
      this.warmObserver.observe(video);
      this.observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        update();
      }, { threshold: [0, 0.25] });
      this.observer.observe(video);
    } else { nearby = visible = true; update(); }
    sync();
  }
  disconnectedCallback() {
    this.abort?.abort();
    this.warmObserver?.disconnect();
    this.observer?.disconnect();
    this.querySelector('video')?.pause();
  }
});
